// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Rupee$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/currencies/inr/Rupee.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getPaymentHistoryInfoView(data) {
  return Belt_List.map(data.payment_history, (function (payment_info) {
                return {
                        amount: Rupee$Catalyst.toCurrencyString(Rupee$Catalyst.toRupee(payment_info.amount)),
                        status: payment_info.status,
                        lead_id: payment_info.lead_id,
                        transaction_id: payment_info.transaction_id,
                        created_at: Timestamp$Catalyst.toString(payment_info.created_at, "DD/MM/YYYY, HH:mm A"),
                        updated_at: Timestamp$Catalyst.toString(payment_info.updated_at, "DD/MM/YYYY, HH:mm A")
                      };
              }));
}

export {
  getPaymentHistoryInfoView ,
  
}
/* Timestamp-Catalyst Not a pure module */
